import { EdgeSelectionIndicatorInstaller } from "yfiles";
export default class CustomSelectionInstaller extends EdgeSelectionIndicatorInstaller {
    getStroke() {
        return null;
    }
}
